import React from 'react';

import PropTypes from 'prop-types';
import { Input, Select } from 'semantic-ui-react';

import { OTHER_OPTION, REJECTION_OPTIONS } from './ContentSuggestionReasonInputs.constants';
import {
  getRawReasonPlaceholder,
  getRawReasonValue,
  getRejectedSelectValue,
} from './ContentSuggestionReasonInputs.utils';

import './ContentSuggestionReasonInputs.scss';

const propTypes = {
  suggestionId: PropTypes.string.isRequired,
  reason: PropTypes.string.isRequired,
  onEditSuggestionReason: PropTypes.func.isRequired,
  isReviewed: PropTypes.bool.isRequired,
  rejected: PropTypes.bool.isRequired,
  approved: PropTypes.bool.isRequired,
};

const defaultProps = {};

export default function ContentSuggestionReasonInputs({
  suggestionId,
  reason,
  isReviewed,
  onEditSuggestionReason,
  rejected,
  approved,
}) {
  const showRawReasonInput =
    !isReviewed || approved || (rejected && reason.startsWith(OTHER_OPTION));
  const showRejectedSelect = rejected;

  const rejectedOptions = REJECTION_OPTIONS.map((option) => ({
    key: option,
    text: option,
    value: option,
  }));

  function onRejectedSelectChange(e, { value }) {
    onEditSuggestionReason(suggestionId, value);
  }

  function onRawReasonInputChange(e, { value }) {
    if (!rejected) {
      onEditSuggestionReason(suggestionId, value);
    } else {
      onEditSuggestionReason(suggestionId, `${OTHER_OPTION}: ${value}`);
    }
  }

  return (
    <div className="content-suggestion-reason-inputs">
      {showRejectedSelect && (
        <Select
          options={rejectedOptions}
          value={getRejectedSelectValue(reason)}
          onChange={onRejectedSelectChange}
          placeholder="Select a reason for rejection"
        />
      )}
      {showRawReasonInput && (
        <Input
          value={getRawReasonValue(reason, rejected)}
          disabled={!isReviewed}
          placeholder={getRawReasonPlaceholder(isReviewed, approved, rejected)}
          onChange={onRawReasonInputChange}
        />
      )}
    </div>
  );
}

ContentSuggestionReasonInputs.propTypes = propTypes;
ContentSuggestionReasonInputs.defaultProps = defaultProps;
